
export const portfolioBid = {
  id: 'portfolio-bid-strategy',
  name: _TL_('Portfolio bid strategies'), // Show in summary bar and page title
  route: 'portfoliobidstrategy',
  checkPermission: permissions =>
    permissions.dynamic.PortfolioBidStrategy
        // moved to sub-item under "planning/bid-strategies" rather than standlong item
        && !(permissions.IsDataExclusionEnabled || permissions.dynamic.DataExclusions),
};

export const portfolioBidStrategyPage = {
  id: 'portfolio-bid-strategy',
  name: _TL_('Portfolio bid strategies'), // Show in tools menu
  children: [
    portfolioBid,
  ],
};
